// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: 0cBs82jKfC
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { AntdInput } from "@plasmicpkgs/antd5/skinny/registerInput";
import { inputHelpers as AntdInput_Helpers } from "@plasmicpkgs/antd5/skinny/registerInput";
import Button from "../../Button"; // plasmic-import: qD6dz0yVMKR/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicDeveloperModal.module.css"; // plasmic-import: 0cBs82jKfC/css

createPlasmicElementProxy;

export const PlasmicDeveloperModal__VariantProps = new Array();

export const PlasmicDeveloperModal__ArgProps = new Array();

const $$ = {};

function PlasmicDeveloperModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "devClientKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
        onMutate: p.generateOnMutateForSpec("value", AntdInput_Helpers)
      },
      {
        path: "devWebHookKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
        onMutate: p.generateOnMutateForSpec("value", AntdInput_Helpers)
      },
      {
        path: "clientKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
        onMutate: p.generateOnMutateForSpec("value", AntdInput_Helpers)
      },
      {
        path: "webHookKey.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
        onMutate: p.generateOnMutateForSpec("value", AntdInput_Helpers)
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox___040Dv)}>
        <div className={classNames(projectcss.all, sty.freeBox___9142)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text___955LA
            )}
          >
            <React.Fragment>
              <React.Fragment>{""}</React.Fragment>
              {
                <h6
                  className={classNames(
                    projectcss.all,
                    projectcss.h6,
                    projectcss.__wab_text,
                    sty.h6___1XIhb
                  )}
                >
                  {"For Production"}
                </h6>
              }

              <React.Fragment>{""}</React.Fragment>
            </React.Fragment>
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__na9Cl)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__tLilP
            )}
          >
            {"Add WebHook Client Key"}
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__wvp3)}>
          {(() => {
            const child$Props = {
              className: classNames("__wab_instance", sty.clientKey),
              onChange: p.generateStateOnChangePropForCodeComponents(
                $state,
                "value",
                ["clientKey", "value"],
                AntdInput_Helpers
              ),
              placeholder: "Enter WebHook Client Key",
              value: p.generateStateValueProp($state, ["clientKey", "value"])
            };
            p.initializeCodeComponentStates(
              $state,
              [
                {
                  name: "value",
                  plasmicStateName: "clientKey.value"
                }
              ],

              [],
              AntdInput_Helpers ?? {},
              child$Props
            );
            return (
              <AntdInput
                data-plasmic-name={"clientKey"}
                data-plasmic-override={overrides.clientKey}
                {...child$Props}
              />
            );
          })()}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox___0E69R)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__ynk39
            )}
          >
            {"Add WebHook Url"}
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__xEkqu)}>
          {(() => {
            const child$Props = {
              className: classNames("__wab_instance", sty.webHookKey),
              onChange: p.generateStateOnChangePropForCodeComponents(
                $state,
                "value",
                ["webHookKey", "value"],
                AntdInput_Helpers
              ),
              placeholder: "Enter WebHook Url",
              value: p.generateStateValueProp($state, ["webHookKey", "value"])
            };
            p.initializeCodeComponentStates(
              $state,
              [
                {
                  name: "value",
                  plasmicStateName: "webHookKey.value"
                }
              ],

              [],
              AntdInput_Helpers ?? {},
              child$Props
            );
            return (
              <AntdInput
                data-plasmic-name={"webHookKey"}
                data-plasmic-override={overrides.webHookKey}
                {...child$Props}
              />
            );
          })()}
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__yJM9)}>
        <div className={classNames(projectcss.all, sty.freeBox__r221Z)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__jiDiW
            )}
          >
            <React.Fragment>
              <React.Fragment>{""}</React.Fragment>
              {
                <h6
                  className={classNames(
                    projectcss.all,
                    projectcss.h6,
                    projectcss.__wab_text,
                    sty.h6__griFs
                  )}
                >
                  {"For Development"}
                </h6>
              }

              <React.Fragment>{""}</React.Fragment>
            </React.Fragment>
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__eCo9H)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__yUKc
            )}
          >
            {"Add WebHook Client Key"}
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__a2Lny)}>
          {(() => {
            const child$Props = {
              className: classNames("__wab_instance", sty.devClientKey),
              onChange: p.generateStateOnChangePropForCodeComponents(
                $state,
                "value",
                ["devClientKey", "value"],
                AntdInput_Helpers
              ),
              placeholder: "Enter WebHook Client Key",
              value: p.generateStateValueProp($state, ["devClientKey", "value"])
            };
            p.initializeCodeComponentStates(
              $state,
              [
                {
                  name: "value",
                  plasmicStateName: "devClientKey.value"
                }
              ],

              [],
              AntdInput_Helpers ?? {},
              child$Props
            );
            return (
              <AntdInput
                data-plasmic-name={"devClientKey"}
                data-plasmic-override={overrides.devClientKey}
                {...child$Props}
              />
            );
          })()}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__iqeO6)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__vX2Du
            )}
          >
            {"Add WebHook Url"}
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__p6ZWs)}>
          {(() => {
            const child$Props = {
              className: classNames("__wab_instance", sty.devWebHookKey),
              onChange: p.generateStateOnChangePropForCodeComponents(
                $state,
                "value",
                ["devWebHookKey", "value"],
                AntdInput_Helpers
              ),
              placeholder: "Enter WebHook Url",
              value: p.generateStateValueProp($state, [
                "devWebHookKey",
                "value"
              ])
            };
            p.initializeCodeComponentStates(
              $state,
              [
                {
                  name: "value",
                  plasmicStateName: "devWebHookKey.value"
                }
              ],

              [],
              AntdInput_Helpers ?? {},
              child$Props
            );
            return (
              <AntdInput
                data-plasmic-name={"devWebHookKey"}
                data-plasmic-override={overrides.devWebHookKey}
                {...child$Props}
              />
            );
          })()}
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox___1Xzzr)}>
        <Button
          data-plasmic-name={"saveBtn"}
          data-plasmic-override={overrides.saveBtn}
          className={classNames("__wab_instance", sty.saveBtn)}
        >
          {"Save"}
        </Button>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "clientKey",
    "webHookKey",
    "devClientKey",
    "devWebHookKey",
    "saveBtn"
  ],

  clientKey: ["clientKey"],
  webHookKey: ["webHookKey"],
  devClientKey: ["devClientKey"],
  devWebHookKey: ["devWebHookKey"],
  saveBtn: ["saveBtn"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDeveloperModal__ArgProps,
          internalVariantPropNames: PlasmicDeveloperModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDeveloperModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDeveloperModal";
  } else {
    func.displayName = `PlasmicDeveloperModal.${nodeName}`;
  }
  return func;
}

export const PlasmicDeveloperModal = Object.assign(
  // Top-level PlasmicDeveloperModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    clientKey: makeNodeComponent("clientKey"),
    webHookKey: makeNodeComponent("webHookKey"),
    devClientKey: makeNodeComponent("devClientKey"),
    devWebHookKey: makeNodeComponent("devWebHookKey"),
    saveBtn: makeNodeComponent("saveBtn"),
    // Metadata about props expected for PlasmicDeveloperModal
    internalVariantProps: PlasmicDeveloperModal__VariantProps,
    internalArgProps: PlasmicDeveloperModal__ArgProps
  }
);

export default PlasmicDeveloperModal;
/* prettier-ignore-end */
